import api from '@pray/shared/utils/api';

export async function getPrayTvSlotAssignments({
  artistId,
}: {
  artistId?: string;
} = {}) {
  const url = '/web/studio/pray-tv/slot-assignments';
  const params = new URLSearchParams();
  if (artistId) params.set('artist_id', artistId);

  const queryString = params.toString();
  const response = await api.executeGetRequest(queryString ? `${url}?${queryString}` : url);

  return response.data;
}
